'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nodePolyglot = require('node-polyglot');

var _nodePolyglot2 = _interopRequireDefault(_nodePolyglot);

var _reactRedux = require('react-redux');

var _reactAddonsUpdate = require('react-addons-update');

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('components');

var _reactDocumentMeta = require('react-document-meta');

var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);

var _reactBootstrap = require('react-bootstrap');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _users = require('redux/modules/users');

var _utils = require('utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Account = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    destroyed: state.users.destroyed,
    user: state.auth.user,
    loading: state.auth.loading,
    error: state.auth.error
  };
}, (0, _extends3.default)({}, authActions, { destroy: _users.destroy })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Account, _Component);

  function Account() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Account);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Account.__proto__ || (0, _getPrototypeOf2.default)(Account)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      locale: _this.props.user.lang,
      password: null,
      newPassword: null,
      newPasswordConfirmation: null,
      showError: false,
      showPasswordChange: false,
      snackbar: (0, _utils.snackbarInitialState)()
    }, _this.onImageCreatedReceived = function (data) {
      var updateAvatar = _this.props.updateAvatar;
      var image = data.image;

      updateAvatar(image);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Account, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (socket && !this.onImageCreatedListener) {
        this.onImageCreatedListener = socket.on('api.image-created', this.onImageCreatedReceived);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (socket && this.onImageCreatedListener) {
        socket.removeListener('on', this.onImageCreatedListener);
        this.onImageCreatedListener = null;
      }
    }
  }, {
    key: 'hideSnackbar',
    value: function hideSnackbar() {
      var snackbar = this.state.snackbar;


      snackbar = (0, _reactAddonsUpdate2.default)(snackbar, {
        $merge: {
          id: 0,
          isActive: false
        }
      });

      this.setState({ snackbar: snackbar });
    }
  }, {
    key: 'handleDeleteImage',
    value: function handleDeleteImage(imageId) {
      var _props = this.props,
          deleteImage = _props.deleteImage,
          loading = _props.loading;


      if (!loading && imageId) {
        deleteImage(imageId);
      }
    }
  }, {
    key: 'handleChangeImage',
    value: function handleChangeImage(image) {
      var _props2 = this.props,
          saveImage = _props2.saveImage,
          loading = _props2.loading;


      if (!loading) {
        saveImage(image);
      }
    }
  }, {
    key: 'handleDismissSnackbar',
    value: function handleDismissSnackbar() {
      this.hideSnackbar();
    }
  }, {
    key: 'handleChangePassword',
    value: function handleChangePassword(event) {
      this.setState({
        newPassword: event.target.value
      });
    }
  }, {
    key: 'handleChangePasswordConfirmation',
    value: function handleChangePasswordConfirmation(event) {
      this.setState({
        newPasswordConfirmation: event.target.value
      });
    }
  }, {
    key: 'handleChangeCurrentPassword',
    value: function handleChangeCurrentPassword(event) {
      this.setState({
        password: event.target.value
      });
    }
  }, {
    key: 'handleShowPasswordChange',
    value: function handleShowPasswordChange() {
      this.setState({
        showPasswordChange: !this.state.showPasswordChange
      });
    }
  }, {
    key: 'handleCancelButton',
    value: function handleCancelButton() {
      this.refs.accountOverlay.hide();
    }
  }, {
    key: 'handleDestroyAccount',
    value: function handleDestroyAccount() {
      var destroy = this.props.destroy; // eslint-disable-line no-shadow

      destroy('me', true).then(function (res) {
        if (res.type === 'caligram/users/DESTROY_SUCCESS') {
          window.location.href = '/logout';
        } else {
          console.error('Could not delete user');
        }
      });
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this2 = this;

      var _props3 = this.props,
          save = _props3.save,
          loading = _props3.loading,
          user = _props3.user;
      var _refs = this.refs,
          name = _refs.name,
          email = _refs.email;
      var _state = this.state,
          newPassword = _state.newPassword,
          newPasswordConfirmation = _state.newPasswordConfirmation,
          password = _state.password,
          locale = _state.locale,
          snackbar = _state.snackbar;

      var payload = {
        email: email.value,
        name: name.value,
        new_password: newPassword,
        new_password_confirmation: newPasswordConfirmation,
        password: password,
        avatar: user.image,
        lang: locale
      };

      if (!loading) {
        save(payload).then(function (res) {
          if (res.type === authActions.SAVE_FAIL) {
            _this2.setState({ showError: true });
          } else if (res.type === authActions.SAVE_SUCCESS) {
            var updatedSnackbar = (0, _reactAddonsUpdate2.default)(snackbar, {
              $merge: {
                id: user.id,
                isActive: true,
                action: false
              }
            });

            _this2.setState({ showError: false, snackbar: updatedSnackbar, showPasswordChange: false });
          }
        });
      }
    }
  }, {
    key: 'switchLocale',
    value: function switchLocale(event) {
      this.setState({ locale: event.target.value });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          user = _props4.user,
          error = _props4.error,
          loading = _props4.loading;
      var locale = this.state.locale;


      var accountPhrases = require('./../../locales/' + locale + '/account.js');
      var appPhrases = require('./../../locales/' + locale + '/app.js');

      var polyglot = new _nodePolyglot2.default({
        locale: locale,
        phrases: (0, _extends3.default)({}, accountPhrases, appPhrases)
      });
      var _state2 = this.state,
          snackbar = _state2.snackbar,
          newPassword = _state2.newPassword,
          newPasswordConfirmation = _state2.newPasswordConfirmation,
          password = _state2.password,
          showError = _state2.showError;

      var options = [{ value: 'fr', label: polyglot.t('account.french') }, { value: 'en', label: polyglot.t('account.english') }];

      var emailGroupClass = (0, _classnames2.default)({
        'form-group': true,
        'has-error': error.hasOwnProperty('email')
      });

      var nameGroupClass = (0, _classnames2.default)({
        'form-group': true,
        'has-error': error.hasOwnProperty('name')
      });

      var passwordGroupClass = (0, _classnames2.default)({
        'form-group': true,
        'has-error': error.hasOwnProperty('password') || error.hasOwnProperty('new_password') || error.hasOwnProperty('new_password_confirmation')
      });

      var saveClassName = (0, _classnames2.default)({
        glyphicon: true,
        'glyphicon-refresh': loading,
        'cg-spinner': loading
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactDocumentMeta2.default, { title: polyglot.t('account.meta_title') }),
        _react2.default.createElement(
          'div',
          { className: 'header' },
          _react2.default.createElement(
            'h1',
            null,
            polyglot.t('account.title')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'results' },
          showError && error && _react2.default.createElement(_components.BasicError, { error: error }),
          _react2.default.createElement(
            'form',
            { action: '' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-6' },
                _react2.default.createElement(
                  'div',
                  { className: nameGroupClass },
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'name' },
                    polyglot.t('account.form.name')
                  ),
                  _react2.default.createElement('input', {
                    id: 'name',
                    ref: 'name',
                    name: 'name',
                    type: 'text',
                    className: 'form-control',
                    placeholder: polyglot.t('account.form.name'),
                    defaultValue: user.name
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: emailGroupClass },
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'email' },
                    polyglot.t('account.form.email')
                  ),
                  _react2.default.createElement('input', {
                    id: 'email',
                    ref: 'email',
                    name: 'email',
                    type: 'email',
                    className: 'form-control',
                    placeholder: polyglot.t('account.form.email'),
                    defaultValue: user.email
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'form-group' },
                  _react2.default.createElement(
                    'label',
                    null,
                    polyglot.t('account.chooseLanguage')
                  ),
                  _react2.default.createElement(
                    'select',
                    {
                      className: 'form-control react-select',
                      onChange: this.switchLocale.bind(this),
                      defaultValue: this.state.locale
                    },
                    options.map(function (o) {
                      return _react2.default.createElement(
                        'option',
                        { value: o.value, key: o.value },
                        o.label
                      );
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'form-group' },
                  _react2.default.createElement(
                    _reactBootstrap.Button,
                    { onClick: this.handleShowPasswordChange.bind(this) },
                    polyglot.t('account.form.change_password')
                  )
                ),
                this.state.showPasswordChange && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'form-group' },
                    _react2.default.createElement(
                      'label',
                      { htmlFor: 'password' },
                      polyglot.t('account.form.password')
                    ),
                    _react2.default.createElement(_components.PasswordInput, {
                      id: 'password',
                      className: 'form-control password',
                      placeholder: polyglot.t('account.form.password'),
                      defaultValue: password,
                      onChange: this.handleChangeCurrentPassword.bind(this),
                      polyglot: polyglot
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: passwordGroupClass },
                    _react2.default.createElement(
                      'label',
                      { htmlFor: 'new_password' },
                      polyglot.t('account.form.new_password')
                    ),
                    _react2.default.createElement(_components.PasswordInput, {
                      id: 'new_password',
                      ref: 'newPassword',
                      className: 'form-control password',
                      placeholder: polyglot.t('account.form.new_password'),
                      defaultValue: newPassword,
                      onChange: this.handleChangePassword.bind(this),
                      polyglot: polyglot
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'form-group' },
                    _react2.default.createElement(
                      'label',
                      { htmlFor: 'password_confirmation' },
                      polyglot.t('account.form.new_password')
                    ),
                    _react2.default.createElement(_components.PasswordInput, {
                      id: 'password_confirmation',
                      className: 'form-control password',
                      placeholder: polyglot.t('account.form.new_password'),
                      defaultValue: newPasswordConfirmation,
                      onChange: this.handleChangePasswordConfirmation.bind(this),
                      polyglot: polyglot
                    })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-6' },
                _react2.default.createElement(
                  'div',
                  { style: { width: '175px' } },
                  _react2.default.createElement(_components.ImageBox, {
                    handleChangeImage: this.handleChangeImage.bind(this),
                    handleDeleteImage: this.handleDeleteImage.bind(this),
                    loading: loading,
                    image: user.avatar,
                    polyglot: polyglot
                  })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'form-actions no-margin text-left' },
              _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  className: 'btn btn-primary',
                  onClick: this.handleSave.bind(this)
                },
                _react2.default.createElement('i', { className: saveClassName }),
                ' ',
                polyglot.t('account.form.submit')
              ),
              _react2.default.createElement(
                'div',
                { className: 'pull-right' },
                _react2.default.createElement(
                  _reactBootstrap.OverlayTrigger,
                  {
                    trigger: 'click',
                    placement: 'top',
                    ref: 'accountOverlay',
                    rootClose: true,
                    overlay: _react2.default.createElement(
                      _reactBootstrap.Popover,
                      { id: 'accountPopover', className: 'notification-item-popover' },
                      _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-xs-4 account-sad-buddy' },
                          _react2.default.createElement('i', { className: 'icon-cg-buddy-sad' })
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'col-xs-8' },
                          _react2.default.createElement(
                            'form',
                            null,
                            _react2.default.createElement(
                              'b',
                              { className: 'small' },
                              polyglot.t('account.popover.title')
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'popover-actions' },
                              _react2.default.createElement(
                                'div',
                                { className: 'buttons' },
                                _react2.default.createElement(
                                  'button',
                                  {
                                    type: 'button',
                                    className: 'btn btn-default btn-outline',
                                    onClick: this.handleCancelButton.bind(this)
                                  },
                                  polyglot.t('account.button.cancel')
                                ),
                                '\xA0',
                                _react2.default.createElement(
                                  'button',
                                  {
                                    type: 'button',
                                    className: 'btn btn-primary',
                                    onClick: this.handleDestroyAccount.bind(this)
                                  },
                                  polyglot.t('account.button.delete')
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  },
                  _react2.default.createElement(
                    'button',
                    {
                      ref: 'btnDestroy',
                      type: 'button',
                      className: 'btn btn-link normal-case',
                      onClick: this.handleDeleteButton
                    },
                    polyglot.t('account.button.remove')
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(_components.Snackbar, (0, _extends3.default)({
          ref: 'snackbar'
        }, snackbar, {
          message: polyglot.t('snackbar.accountUpdated'),
          style: (0, _utils.snackbarStyle)(),
          onDismiss: this.handleDismissSnackbar.bind(this),
          polyglot: polyglot
        }))
      );
    }
  }], [{
    key: 'fetchData',
    value: function fetchData(getState, dispatch) {
      if (!(0, _auth.isLoaded)(getState())) {
        return dispatch((0, _auth.load)());
      }
    }
  }]);
  return Account;
}(_react.Component), _class2.propTypes = {
  deleteImage: _propTypes2.default.func,
  destroy: _propTypes2.default.func.isRequired,
  destroyed: _propTypes2.default.object,
  error: _propTypes2.default.any,
  load: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  save: _propTypes2.default.func,
  saveImage: _propTypes2.default.func,
  updateAvatar: _propTypes2.default.func,
  user: _propTypes2.default.object.isRequired
}, _temp2)) || _class);
exports.default = Account;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Account/Account.js
// module id = 2256
// module chunks = 0